import { render, staticRenderFns } from "./labelUpload.vue?vue&type=template&id=713659fa"
import script from "./labelUpload.vue?vue&type=script&lang=js"
export * from "./labelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713659fa')) {
      api.createRecord('713659fa', component.options)
    } else {
      api.reload('713659fa', component.options)
    }
    module.hot.accept("./labelUpload.vue?vue&type=template&id=713659fa", function () {
      api.rerender('713659fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/lang/labelUpload.vue"
export default component.exports